import { apiCheckBlockedCountry } from "@app/api";

let signupAllowedPromise: Promise<boolean> | null = null;

async function requestWebSignupAllowed(): Promise<boolean> {
  const res = await apiCheckBlockedCountry();
  return res.data?.data?.status === true;
}

export function isWebSignupAllowed(): Promise<boolean> {
  if (!signupAllowedPromise) {
    signupAllowedPromise = requestWebSignupAllowed().catch((error) => {
      console.error("Blocked-country check failed:", error);
      signupAllowedPromise = null;
      return false;
    });
  }
  return signupAllowedPromise;
}
